import { Observable } from 'rxjs';
import { ResourceCountries } from '../models/resource-countries.model';

export abstract class ResourceCountriesRepository {
    abstract getResourceCountries(): Observable<ResourceCountries>;
}
